import { AbstractModel } from '../models/abstract.model';
import { IsString, IsNumber } from 'class-validator';
import { HistoryInterface } from './history.interface';

export class HistoryModel extends AbstractModel implements HistoryInterface {

    @IsNumber()
    public _entityId: number = 0;

    @IsString()
    public _entityName: string;

    @IsString()
    public change: string = '';

    @IsString()
    public message: string = '';

}
